import { Types } from '@scorenco/core';

import { JsonLd, PageSeo } from '../../../../../../components';
import { getEventTeams } from '../utils/eventGuards';

type EventMetadataProps = { event?: Types.Competitions_Event_Detail };

export const EventMetadata = ({ event }: EventMetadataProps) => {
  if (!event) {
    return null;
  }

  const teams = getEventTeams(event.teams);

  return (
    <>
      <PageSeo
        title={`${teams[0]?.name_in_competition} - ${teams[1]?.name_in_competition} - ${event.sport?.name}`}
        description={`Suivez le live de ce match de ${event.sport?.name} entre ${teams[0]?.name_in_competition} et ${teams[1]?.name_in_competition} en direct sur Score'n'co 🔵🟢`}
        sharedImage={event.event?.share_image_url}
        url={event.url}
      />
      <JsonLd
        id="jsonld-sports-event"
        value={{
          '@context': 'https://schema.org',
          '@type': 'SportsEvent',
          url: event.url?.includes('match-tournoi')
            ? event.url
            : (event.url?.split('?')[0] as string),
          name: `${teams[0]?.name_in_competition} - ${teams[1]?.name_in_competition}`,
          image: event.event?.share_image_url,
          awayTeam: {
            '@type': 'SportsTeam',
            name: teams[1]?.name_in_competition,
            logo: teams[1]?.logo,
          },
          homeTeam: {
            '@type': 'SportsTeam',
            name: teams[0]?.name_in_competition,
            logo: teams[0]?.logo,
          },
          sport: event.sport?.name,
          startDate: event.time || event.date,
          location: event.place && {
            '@type': 'Place',
            address: {
              '@type': 'PostalAddress',
              addressLocality: event.place.city?.name,
              addressRegion: 'FR',
              postalCode: event.place.postal_code,
              streetAddress: event.place.address,
            },
          },
        }}
      />
    </>
  );
};
